import { useCallback, useState } from "react"
import { type Locale, setLocale } from "@/shared/lib/i18n"
import { useUpdateUser } from "../api/mutations"
import { useCurrentUserId } from "./use-current-user-id"

export type InterfaceLanguageEditor = {
	selected: Locale
	select: (next: Locale) => void
	isDirty: boolean
	commit: () => Promise<void>
}

export function useInterfaceLanguageEditor({
	initial,
}: {
	initial: Locale
}): InterfaceLanguageEditor {
	const userId = useCurrentUserId()
	const updateUser = useUpdateUser()
	const [selected, setSelected] = useState<Locale>(initial)

	const isDirty = selected !== initial

	const select = useCallback((next: Locale) => {
		setSelected(next)
	}, [])

	const commit = useCallback(async () => {
		if (selected === initial) return
		await updateUser.mutateAsync({
			id: userId,
			app_language: selected,
		})
		setLocale(selected, { reload: false })
	}, [userId, initial, selected, updateUser])

	return { selected, select, isDirty, commit }
}
